import React, { useState, useEffect } from 'react';
import ReactMapboxGl, { Marker, Popup } from 'react-mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import CustomMarker from './CustomMarker';
import CinemaPopup from './CinemaPopup';

// Initialize the map
const Map = ReactMapboxGl({
    accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
});

const loadingMessages = [
    "🎬 Préparation de votre expérience cinéma...",
    "🍿 Recherche des meilleures séances...",
    "🎪 Localisation des cinémas proches...",
    "🎭 Chargement des films à l'affiche...",
    "🎫 Optimisation de votre recherche...",
    "🌟 Découverte des nouveautés...",
    "🎥 Préparation de la carte interactive...",
    "🎞️ Un instant, nous finalisons..."
];

const CinemaMap = ({ cinemas, onMapLoaded }) => {
    const [selectedCinema, setSelectedCinema] = useState(null);
    const [isMapReady, setIsMapReady] = useState(false);
    const [currentMessage, setCurrentMessage] = useState(loadingMessages[0]);

    useEffect(() => {
        console.log('Selected cinema:', selectedCinema);
    }, [selectedCinema]);

    useEffect(() => {
        if (!isMapReady) {
            const interval = setInterval(() => {
                setCurrentMessage(prev => {
                    const currentIndex = loadingMessages.indexOf(prev);
                    const nextIndex = (currentIndex + 1) % loadingMessages.length;
                    return loadingMessages[nextIndex];
                });
            }, 2000);

            return () => clearInterval(interval);
        }
    }, [isMapReady]);

    const handleMarkerClick = (cinema) => {
        console.log("Clicking on cinema:", cinema);
        if (cinema.coordinates && cinema.coordinates.lat && cinema.coordinates.lon) {
            setSelectedCinema(prevSelected =>
                prevSelected?.id === cinema.id ? null : cinema
            );
        }
    };

    const handlePopupClose = () => {
        console.log("Closing popup");
        setSelectedCinema(null);
    };

    const handleMapLoad = () => {
        console.log('Map style loaded');
        setIsMapReady(true);
        onMapLoaded && onMapLoaded();
    };

    return (
        <div className="relative w-full h-full">
            {!isMapReady && (
                <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
                    <div className="flex flex-col items-center space-y-4">
                        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
                        <p className="text-gray-600">{currentMessage}</p>
                    </div>
                </div>
            )}
            <Map
                style="mapbox://styles/mapbox/streets-v11"
                containerStyle={{
                    height: '100vh',
                    width: '100%'
                }}
                center={[2.3488, 48.8534]}
                zoom={[12]}
                pitch={[0]}
                bearing={[0]}
                renderWorldCopies={false}
                maxBounds={[
                    [2.0, 48.5],
                    [2.6, 49.0]
                ]}
                onStyleLoad={handleMapLoad}
            >
                {cinemas.map((cinema) => (
                    <Marker
                        key={cinema.id}
                        coordinates={[cinema.coordinates.lon, cinema.coordinates.lat]}
                        anchor="bottom"
                    >
                        <div onClick={() => handleMarkerClick(cinema)}>
                            <CustomMarker cinema={cinema} />
                        </div>
                    </Marker>
                ))}

                {selectedCinema && (
                    <Popup
                        coordinates={[selectedCinema.coordinates.lon, selectedCinema.coordinates.lat]}
                        offset={{
                            'bottom': [0, -10],
                            'top': [0, 10]
                        }}
                        onClose={handlePopupClose}
                    >
                        <CinemaPopup cinema={selectedCinema} />
                    </Popup>
                )}
            </Map>
        </div>
    );
};

export default CinemaMap;